module.exports = __webpack_public_path__ + "media/img/frontend_application/map/indonesia-d391903071fd99ee34bfd9adeaba2f88.webp";